import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import { InvalidMarketInfoModel } from "../../InvalidCheck/models/InvalidMarketInfoModel";
import MarketInfoModel from "../models/MarketInfoModel";
import MarketInfoQueryModel from "../models/MarketInfoQueryModel";

export interface SearchMarketInfoParam {
    pageSize: number,
    query: MarketInfoQueryModel
}

export interface GetMarketInfoByIdParam {
    id: number,
}

export interface DeleteMarketInfoByIdParam {
    id: number,
}

export interface CorrectInvalidMarketInfoParam {
    id: number,
    chartererId: string | null,
    cargoTypeId: number | null,
    ownerId: string | null,
    loadPort: number | null,
    disport: number | null
}

export interface MarketInfoImportModel {
    rowRef: string;
    type: string;
    vesselName: string;
    tonnageId: string | null;
    chartererName: string;
    ownerName: string;
    cargoTypeName: string;
    cargoTypeId: number | null;
    loadPortName: string;
    loadPortId: number | null;
    disportName: string;
    disportId: number | null;
    chartererRate: number | null;
    ownerRate: number | null;
    duration: number | null;
    size: number | null;
    remarks: string;
    isDuplicate: boolean;
    validationErrors: string[];
}

const MarketInfoApi = {
    Search(param: SearchMarketInfoParam) {
        return Api.post<SearchMarketInfoParam, BaseResponse<MarketInfoModel[]>>("/api/marketInfo/Search", param);
    },
    GetUpdatedData() {
        return Api.get<null, BaseResponse<MarketInfoModel[]>>("/api/marketInfo/GetUpdatedData", null);
    },
    Save(param: MarketInfoModel) {
        return Api.post<MarketInfoModel, BaseResponse<MarketInfoModel>>("/api/marketInfo/Save", param);
    },
    GetById(param: GetMarketInfoByIdParam) {
        return Api.get<GetMarketInfoByIdParam, BaseResponse<MarketInfoModel>>("/api/marketInfo/GetById", param);
    },
    Delete(param: DeleteMarketInfoByIdParam) {
        return Api.post<DeleteMarketInfoByIdParam, BaseResponse<MarketInfoModel>>("/api/marketInfo/Delete", param);
    },
    GetInvalidMarketInfos() {
        return Api.get<null, BaseResponse<InvalidMarketInfoModel[]>>("/api/marketInfo/GetInvalidMarketInfos", null);
    },
    CorrectInvalid(param: CorrectInvalidMarketInfoParam) {
        return Api.post<CorrectInvalidMarketInfoParam, BaseResponse<MarketInfoModel>>("/api/marketInfo/CorrectInvalid", param);
    },
    ImportMarketInfoFromExcel(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return Api.postForm<BaseResponse<MarketInfoImportModel[]>>("/api/marketInfo/ImportMarketInfoFromExcel", formData);
    },
    ValidateMarketInfoImportData(importData: MarketInfoImportModel[]) {
        return Api.post<MarketInfoImportModel[], BaseResponse<MarketInfoImportModel[]>>("/api/marketInfo/ValidateMarketInfoImportData", importData);
    },
    SaveMarketInfoImportData(importData: MarketInfoImportModel[]) {
        return Api.post<MarketInfoImportModel[], BaseResponse<string>>("/api/marketInfo/SaveMarketInfoImportData", importData);
    },
};
export default MarketInfoApi;